module.exports = "<app-barra-superior></app-barra-superior>\r\n<ngx-paypal [config]=\"payPalConfig\"></ngx-paypal>"